module.exports = "<p>\r\n  enrutamientopqr works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/enrutamientos/enrutamientopqr/enrutamientopqr.component.html
// module id = ../../../../../src/app/main/enrutamientos/enrutamientopqr/enrutamientopqr.component.html
// module chunks = main